/**
 * group模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const group = {
  // 组创建
  createGroup(params) {
    return $http.post(`${global.API_URL}/sme/group/create`,params);
  },
  // 编辑组
  updateGroup(params) {
    return $http.post(`${global.API_URL}/sme/group/update`,params);
  },
  //组列表分页
  pageGroup(params) {
    return $http.post(`${global.API_URL}/sme/group/page`,params);
  },
  //组删除
  deleteGroup(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/group/delete`,param);
  },
  //根据id查询Group
  selectGroup(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/group/select`,param);
  }
}

export default group;



// WEBPACK FOOTER //
// ./src/api/group.js